import moment from 'moment';
import queryString from 'query-string';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  clearFilters as clearFiltersAction,
  saveFilters as saveFiltersAction,
} from '../../actions/filters-actions';

const withFilterActions = (initialFilters) => (WrappedComponent) =>
  class extends Component {
    state = {};

    componentWillMount() {
      this.setQueryToState();
      this.unlisten = this.props.history.listen(() => {
        this.setQueryToState();
      });
    }

    componentWillUnmount() {
      this.unlisten();
    }

    handleDateFilterChange = (date, name) => {
      this.setState({
        [name]: date ? moment(date).format('YYYY-MM-DDTHH:mm') : undefined,
      });
    };

    handleApply = () => {
      const { saveFilters, history } = this.props;
      const query = queryString.stringify(this.state, {
        arrayFormat: 'bracket',
      });
      saveFilters(query);
      history.replace({ ...history.location, search: query });
    };

    handleDelete = (value, filter) => {
      const updatedFilter = this.state[filter];
      const indexToDelete = updatedFilter.indexOf(value);
      let filterValue = [...updatedFilter];
      filterValue.splice(indexToDelete, 1);
      this.setState({ [filter]: filterValue });
    };

    handleBooleanFilterChange = (name, e, { value }) => {
      this.setState({
        [name]: value,
      });
    };

    handleAdd = (filter, e, { value }) => {
      const currentFilter = this.state[filter];
      if (!currentFilter.includes(value)) {
        this.setState({
          [filter]: [...currentFilter, value],
        });
      }
    };

    handleClear = () => {
      const { location, clearFilters, history } = this.props;
      clearFilters();
      history.push(location ? location.pathname : '/');
    };

    setQueryToState() {
      const {
        history: { location },
      } = this.props;
      const { after, before, first, last, ...filters } = queryString.parse(
        location.search,
        {
          arrayFormat: 'bracket',
        }
      );
      this.setState({ ...initialFilters, ...filters });
    }

    render = () => (
      <WrappedComponent
        onFilterAdd={this.handleAdd}
        onApply={this.handleApply}
        onClear={this.handleClear}
        filters={this.state}
        onFilterDelete={this.handleDelete}
        onBooleanFilterChange={this.onBooleanFilterChange}
        onDateFilterChange={this.handleDateFilterChange}
      />
    );
  };

const mapDispatchToProps = (type) => (dispatch) => ({
  saveFilters: (value) =>
    dispatch(
      saveFiltersAction({
        type,
        value,
      })
    ),
  clearFilters: () =>
    dispatch(
      clearFiltersAction({
        type,
      })
    ),
});

export default (type) => (initialFilters) => (WrappedComponent) =>
  withRouter(
    connect(
      null,
      mapDispatchToProps(type)
    )(withFilterActions(initialFilters)(WrappedComponent))
  );



// WEBPACK FOOTER //
// ./src/component/HOC/withFilterActions.js